import DataStore from 'flux/stores/DataStore.js'
import Masonry from 'react-masonry-component'
import ReactGA from 'react-ga';

const masonryOptions = {
  // transitionDuration: 1000,
  columnWidth: '.gallery__item--standard'
};

const imagesLoadedOptions = {}

class Gallery extends React.Component {
  constructor() {
    super()
    ReactGA.pageview(window.location.pathname + window.location.search);


    const languages = DataStore.getAllLanguages()

    const split = window.location.pathname.split('/')

    let lang = 'sv'
    if (languages.includes(split[1])) {
      lang = split[1]
    }

    let pageData 

    pageData = DataStore.getPageBySlug('galleri', 'sv');

    const childElements = pageData.acf.images.map(function (element, i) {
      return (
        <li key={i} className={`gallery__item gallery__item--${element.category.includes('highlight') ? 'big' : 'standard'}`}>
          <img className="gallery__item__img" src={element.image.sizes.large} />
        </li>
      );
    });

    let all = 'All'
    let bb = 'B&B'
    let bakery = 'Bakery'

    if (lang === 'sv') {
      all = 'Alla'
      bb = 'Logi'
      bakery = 'Bageri'
    } else if (lang === 'fi') {
      all = 'Kaikki'
      bb = 'Maioitus'
      bakery = 'Leipomo'
    }

    this.state = {
      images: pageData.acf.images,
      renderedImages: childElements,
      category: undefined,
      txtAll: all,
      txtBB: bb,
      txtBakery: bakery,
    }
  }

  _setCategory (cat) {
    const childElements = this.state.images.map(function (element, i) {
      if (!cat || element.category.includes(cat)) {
        return (
          <li key={i} className={`gallery__item gallery__item--${element.category.includes('highlight') ? 'big' : 'standard'}`}>
            <img className="gallery__item__img" src={element.image.sizes.large} />
          </li>
        );
      }
    });

    this.setState({
      renderedImages: childElements,
      category: cat
    })
    this.masonry.reloadItems();
  }

  render() {
    return (
      <div className="gallery">
        <div className="gallery__filter">
          <button
            className={`gallery__filter__btn gallery__filter__btn--${ !this.state.category ? 'selected' : ''}`}
            onClick={this._setCategory.bind(this, undefined)}
          >{this.state.txtAll}</button>

          <button
            className={`gallery__filter__btn gallery__filter__btn--${ this.state.category === 'logi' ? 'selected' : ''}`}
            onClick={this._setCategory.bind(this, 'logi')}
          >{this.state.txtBB}</button>

          <button
            className={`gallery__filter__btn gallery__filter__btn--${ this.state.category === 'bageri' ? 'selected' : ''}`}
            onClick={this._setCategory.bind(this, 'bageri')}
          >{this.state.txtBakery}</button>
        </div>
        
        <Masonry
          className={'gallery__list'}
          elementType={'ul'}
          options={masonryOptions}
          ref={function(c) {this.masonry = this.masonry || c.masonry;}.bind(this)}
        >
          { this.state.renderedImages }
        </Masonry>
      </div>
    );
  }
}


export default Gallery;



// WEBPACK FOOTER //
// ./src/scripts/components/Gallery.js